import { render, staticRenderFns } from "./PerformanceReviewDiscussion.vue?vue&type=template&id=270c07dc&scoped=true&"
import script from "./PerformanceReviewDiscussion.vue?vue&type=script&lang=js&"
export * from "./PerformanceReviewDiscussion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270c07dc",
  null
  
)

export default component.exports